var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFavourites = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: 32,
    height: 32,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Favourites") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Star in circle")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#5FBC00",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1,1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "14.6044625 6.17647059 17.1906694 12.3833671 23.9148073 12.3833671 18.5173935 16.9262982 20.811359 24.2799189 14.6044625 19.6247465 8.39756592 24.2799189 10.6915314 16.9262982 5.29411765 12.3833671 12.0182556 12.3833671"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,15 C30,23.2846552 23.2846552,30 15,30 C6.71534483,30 0,23.2846552 0,15 C0,6.71586207 6.71534483,0 15,0 C23.2846552,0 30,6.71586207 30,15 Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFavourites);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/favourites.c2f95e3bfd48c057d0426eac3a242e14.svg";